<template>
    <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
        d="M11.5418 3.00002L9.2085 0.666687V2.41669H0.458496V3.58335H9.2085V5.33335L11.5418 3.00002Z"
        fill="#060607"
        fill-opacity="0.87"/>
    </svg>
</template>
